@if (loading) {
    <app-wait waitText="Please wait while we log you in..."></app-wait>
}
<app-message-box [content]="errors"></app-message-box>
